
import React from "react";
import{Box,Typography,TextField,InputAdornment,FormControl,Select,MenuItem}from"@mui/material";
import SearchRoundedIcon from"@mui/icons-material/SearchRounded";
import Downloads from"./Downloads";

const ESTADOS=[
  {value:"",label:"Todos los estados"},
  {value:"EMITIDA",label:"Emitida"},
  {value:"AUTORIZADA",label:"Autorizada"},
  {value:"DEVUELTA",label:"Devuelta"}
];

export default function Filter({
  search,
  setSearch,
  desde,
  setDesde,
  hasta,
  setHasta,
  estado,
  setEstado,
  dashboardTheme,
  disabled=false,
  canReports=false,
  onBusyChange
}){
  const menuProps={
    disableScrollLock:true,
    keepMounted:true,
    PaperProps:{
      sx:{
        mt:.8,
        minWidth:210,
        maxWidth:"calc(100vw - 24px)",
        borderRadius:"12px",
        bgcolor:dashboardTheme.card_background,
        color:dashboardTheme.text_color,
        border:`1px solid ${dashboardTheme.border_color}`,
        boxShadow:"0 8px 28px rgba(0,0,0,0.14)",
        "& .MuiMenuItem-root":{
          minHeight:42,
          fontSize:14,
          fontWeight:600
        }
      }
    },
    MenuListProps:{
      sx:{py:.6}
    }
  };

  return(
    <Box
      sx={{
        ...dashboardTheme.tableStyles.toolbar,
        display:"flex",
        flexDirection:"column",
        alignItems:"stretch",
        gap:1.6,
        minWidth:0
      }}
    >
      <Box
        sx={{
          display:"flex",
          alignItems:{xs:"stretch",lg:"center"},
          flexDirection:{xs:"column",lg:"row"},
          gap:1.3,
          minWidth:0
        }}
      >
        <Box
          sx={{
            display:"flex",
            alignItems:{xs:"stretch",sm:"center"},
            flexDirection:{xs:"column",sm:"row"},
            flexWrap:"wrap",
            gap:1.2,
            flex:1,
            minWidth:0
          }}
        >
          <Box
            sx={{
              display:"flex",
              alignItems:{xs:"stretch",sm:"center"},
              flexDirection:{xs:"column",sm:"row"},
              gap:1,
              minWidth:0
            }}
          >
            <Typography
              sx={{
                fontSize:14,
                fontWeight:700,
                color:dashboardTheme.text_color,
                whiteSpace:"nowrap"
              }}
            >
              Desde
            </Typography>
            <TextField
              size="small"
              type="date"
              value={desde}
              disabled={disabled}
              onChange={event=>setDesde(event.target.value)}
              inputProps={{max:hasta||undefined}}
              sx={{
                width:{xs:"100%",sm:180},
                ...dashboardTheme.inputStyles
              }}
            />
          </Box>

          <Box
            sx={{
              display:"flex",
              alignItems:{xs:"stretch",sm:"center"},
              flexDirection:{xs:"column",sm:"row"},
              gap:1,
              minWidth:0
            }}
          >
            <Typography
              sx={{
                fontSize:14,
                fontWeight:700,
                color:dashboardTheme.text_color,
                whiteSpace:"nowrap"
              }}
            >
              Hasta
            </Typography>
            <TextField
              size="small"
              type="date"
              value={hasta}
              disabled={disabled}
              onChange={event=>setHasta(event.target.value)}
              inputProps={{min:desde||undefined}}
              sx={{
                width:{xs:"100%",sm:180},
                ...dashboardTheme.inputStyles
              }}
            />
          </Box>

          <FormControl
            size="small"
            disabled={disabled}
            sx={{
              width:{xs:"100%",sm:210},
              flexShrink:0,
              ...dashboardTheme.inputStyles
            }}
          >
            <Select
              value={estado}
              displayEmpty
              size="small"
              onChange={event=>setEstado(event.target.value)}
              MenuProps={menuProps}
              sx={{
                fontSize:14,
                fontWeight:600,
                color:dashboardTheme.text_color,
                borderRadius:"10px",
                "& .MuiSelect-select":{
                  display:"flex",
                  alignItems:"center"
                }
              }}
            >
              {ESTADOS.map(item=>(
                <MenuItem key={item.value||"todos"} value={item.value}>
                  {item.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>

        {canReports&&(
          <Box
            sx={{
              display:"flex",
              alignItems:"center",
              justifyContent:{xs:"flex-start",lg:"flex-end"},
              flexShrink:0,
              minWidth:0
            }}
          >
            <Downloads
              desde={desde}
              hasta={hasta}
              canReports={canReports}
              disabled={disabled}
              onBusyChange={onBusyChange}
            />
          </Box>
        )}
      </Box>

      <TextField
        fullWidth
        size="small"
        placeholder="Buscar por código, número de documento o persona"
        value={search}
        disabled={disabled}
        onChange={event=>setSearch(event.target.value)}
        InputProps={{
          startAdornment:(
            <InputAdornment position="start">
              <SearchRoundedIcon
                sx={{
                  color:dashboardTheme.theme_mode==="dark"
                    ?"rgba(255,255,255,0.62)"
                    :"#6b7280"
                }}
              />
            </InputAdornment>
          )
        }}
        sx={{
          ...dashboardTheme.inputStyles,
          "& .MuiInputBase-input::placeholder":{
            color:dashboardTheme.theme_mode==="dark"
              ?"rgba(255,255,255,0.55)"
              :"#6b7280",
            opacity:1
          }
        }}
      />
    </Box>
  );
}
